var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0645 12.2578C14.3105 12.5312 14.3105 12.9414 14.0371 13.1875L13.2715 13.9531C13.0254 14.2266 12.6152 14.2266 12.3418 13.9531L9.63477 11.2461C9.49805 11.1094 9.44336 10.9453 9.44336 10.7812V10.3164C8.45898 11.082 7.25586 11.5195 5.94336 11.5195C2.79883 11.5195 0.255859 8.97656 0.255859 5.83203C0.255859 2.71484 2.79883 0.144531 5.94336 0.144531C9.06055 0.144531 11.6309 2.71484 11.6309 5.83203C11.6309 7.17188 11.166 8.375 10.4277 9.33203H10.8652C11.0293 9.33203 11.1934 9.41406 11.3301 9.52344L14.0645 12.2578ZM5.94336 9.33203C7.85742 9.33203 9.44336 7.77344 9.44336 5.83203C9.44336 3.91797 7.85742 2.33203 5.94336 2.33203C4.00195 2.33203 2.44336 3.91797 2.44336 5.83203C2.44336 7.77344 4.00195 9.33203 5.94336 9.33203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnSearchIcon);
export default __webpack_public_path__ + "static/media/btn-search-icon.1bc9caf7ad747e62253bab5fb173feef.svg";
export { ForwardRef as ReactComponent };